<template>
  <div class="um-select-tree">
    <el-select
      ref="select"
      v-model="selectValue"
      v-popover:popover
      :multiple="multiple"
      :disabled="disabled"
      :size="selectSize"
      :clearable="clearable"
      :collapse-tags="collapseTags"
      :multiple-limit="multipleLimit"
      :popper-append-to-body="true"
      :filterable="filterable"
      :filter-method="filterMethod"
      :placeholder="placeholder"
      style="width: 100%;"
      :value-key="defaultProps.value"
      @clear="clear"
      @remove-tag="removeTag"
      @visible-change="visibleChange"
    >
      <template v-for="(item,index) in selectOptions">
        <el-option v-if="defaultProps.selectlabel" :key="index" style="display: none;" :value="item[defaultProps.value]" :label="item[defaultProps.selectlabel]" />
        <el-option v-else :key="index" style="display: none;" :value="item[defaultProps.value]" :label="item[defaultProps.label]" />
      </template>
      <el-option
        v-if="options_filter.length"
        disabled
        :value="undefined"
        label=""
        class="el-select-dropdown__item"
        style="height:auto;padding:0;font-weight:400;background: #fff;display: block;zoom:1;clear:both;margin-bottom: 10px;"
      >
        <el-tree
          ref="tree"
          :data="options_filter"
          :props="defaultProps"
          :show-checkbox="multiple"
          :indent="10"
          :check-strictly="checkStrictly"
          :node-key="defaultProps.value"
          :default-expanded-keys="expandedKeys"
          :default-checked-keys="checkedKeys"
          :filter-node-method="filterNode"
          :accordion="accordion"
          :highlight-current="true"
          :expand-on-click-node="expandOnClickNode"
          :check-on-click-node="checkOnClickNode"
          :default-expand-all="expandAll"
          @node-click="handleNodeClick"
          @check="handleCheckChange"
        >
          <span slot-scope="{ node, data }" class="custom-tree-node">
            <!--              {{ node.checked }}-->
            <!--              {{ node.isCurrent }}-->
            <!--              {{ node.disabled }}-->
            <span v-if="node.disabled" :style="{color:'rgba(0,0,0,0.25)',cursor:'not-allowed'}">{{ node.label }}</span>
            <span v-else :style="{color:node.checked?'#2B6FEF':'inherit'}">{{ node.label }}</span>
          </span>
        </el-tree>
      </el-option>
    </el-select>
  </div>
</template>

<script>
import { treeFind, treeEach, treeFilter, treeMap } from 'operation-tree-node'
import emitter from 'element-ui/src/mixins/emitter'
import Locale from 'element-ui/src/mixins/locale'
export default {
  name: 'ElSelectTree',
  mixins: [emitter, Locale],
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    // 提示文字
    placeholder: { type: String, default: '请选择' },
    // 是否禁用
    disabled: { type: Boolean, default: false },
    // 是否多选
    multiple: { type: Boolean, default: false },
    // 输入框尺寸
    size: { type: String, default: '' },
    // 是否可以清空选项
    clearable: { type: Boolean, default: false },
    // 多选时是否将选中值按文字的形式展示
    collapseTags: { type: Boolean, default: false },
    // 多选时用户最多可以选择的项目数，为 0 则不限制
    multipleLimit: { type: Number, default: 0 },
    // tree 数据
    options: { type: Array, default: () => [] },
    // tree 配置选项
    defaultProps: { type: Object, default: () => { return { value: 'id', label: 'label', children: 'children', selectlabel: null } } },
    // tree 手风琴模式
    accordion: { type: Boolean, default: false },
    // tree 是否默认展开所有节点
    expandAll: { type: Boolean, default: false },
    // isLeaf  是否只能选择叶子节点
    isLeaf: { type: Boolean, default: false },
    // 是否开启搜索
    filterable: { type: Boolean, default: true },
    // 绑定value值
    value: { type: [Number, String, Array], default: null }
  },
  data() {
    return {
      console: console,
      width: 150, // popover 宽度
      selectOptions: [] // 下拉框值
      // selectValue: null // 下拉框的值 【本版本 采用name 回显 抛弃id对象方式】
    }
  },
  inject: {
    elForm: {
      default: ''
    },
    elFormItem: {
      default: ''
    }
  },
  computed: {
    _elFormItemSize() {
      return (this.elFormItem || {}).elFormItemSize
    },
    selectSize() {
      return this.size || this._elFormItemSize || (this.$ELEMENT || {}).size || 'small'
    },
    // 下拉框的值
    selectValue: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('change', val)
        // 判断值是否在数据源中
        if (Array.isArray(val)) {
          this.$emit('input', this.selectOptions.filter(item => val.some(i => item[this.defaultProps.value] === i)))
        } else {
          this.$emit('input', this.selectOptions.filter(item => item[this.defaultProps.value] === val))
        }
        this.$nextTick(() => {
          if (!this.$refs.tree) return false
          if (Array.isArray(val)) {
            this.$refs.tree.setCheckedKeys(val)
          } else {
            this.$refs.tree.setCheckedKeys([])
            if (val) {
              this.$refs.tree.setChecked(val, true, false)
            }
          }
        })
      }
    },
    // 设置默认展开的节点
    expandedKeys: {
      get() {
        if (this.value) {
          if (Array.isArray(this.value)) {
            return this.value
          } else {
            return [this.value]
          }
        }
        // 自动展开一级
        if (this.options && this.options.length) {
          let list = []
          this.options.forEach(item => {
            const child = item[this.defaultProps.children]
            if (child && child.length) {
              list = list.concat(child.map(item2 => item2[this.defaultProps.value]))
            }
          })
          return list
        } else {
          return []
        }
      }
    },
    // 设置默认选中的节点
    checkedKeys: {
      get() {
        if (this.value) {
          if (Array.isArray(this.value)) {
            return this.value
          } else {
            return [this.value]
          }
        }
        return []
      }
    },
    // 是否在点击节点的时候展开或者收缩节点， 默认值为 true，如果为 false，则只有点箭头图标的时候才会展开或者收缩节点。
    expandOnClickNode: { get() { return false } },
    // 是否在点击节点的时候选中节点，默认值为 false，即只有在点击复选框时才会选中节点
    checkOnClickNode: { get() { return this.multiple } },
    // 是否父子不关联，当单选的时候取消父子关联关系
    checkStrictly: {
      get() {
        return !this.multiple
      }
    },
    // 过滤之后的tree data
    options_filter: {
      get() {
        return treeMap(this.options, node => {
          // if (this.isLeaf && node[this.defaultProps.children] && node[this.defaultProps.children].length > 0) {
          //   node.disabled = true
          // }
          return {
            ...node
          }
        }, { children: this.defaultProps.children })
      }
    }
  },
  watch: {
    value(val, oldVal) {
      this.setLabel()
    },
    options(val) {
      this.setLabel()
    }
  },
  mounted() {
    this.setLabel()
    this.width = this.$el.clientWidth
  },
  created() {
  },
  methods: {
    // 下拉框显示隐藏
    visibleChange(val) {
      if (!this.$refs.tree) return false
      // 清空选择
      this.$refs.tree.setCheckedKeys([])
      // 恢复默认筛选
      this.$refs.tree.filter('')
      // if ((val && (this.value === null)) || this.value === '' || this.value.length === 0) {
      if (this.value === undefined || this.value === null || this.value === '' || this.value.length === 0) {
        //
      } else {
        // 根据 value 赋值
        if (Array.isArray(this.value)) {
          this.$refs.tree.setCheckedKeys(this.value)
        } else {
          this.$refs.tree.setChecked(this.value, true)
        }
      }
    },
    // 开启自定义搜索  select 不能开启搜索不然会导致 一个删除tag 的事件 无法监听
    filterMethod(val) {
      this.$refs.tree.filter(val)
    },
    // 多选模式下移除tag时触发
    removeTag(val) {
      // const find = treeFind(this.options, node => {
      //   return node[this.defaultProps.value] == val
      // }, { children: this.defaultProps.children })
      // if (find) {
      //   this.$refs.tree.setChecked(find[this.defaultProps.value], false, true)
      // }
    },
    // 可清空的单选模式下用户点击清空按钮时触发
    clear() {
      // if (this.multiple) {
      //   this.$emit('change', [])
      // } else {
      //   this.$emit('change', '')
      // }
      // this.$refs.tree.setCheckedKeys([])
    },
    // 设置回显
    setLabel() {
      if (this.value === null || this.value === '' || this.options.length === 0) {
        this.selectOptions = []
        return false
      }
      this.selectOptions = []
      if (Array.isArray(this.value)) {
        this.value.forEach(item => {
          const find = treeFind(this.options, node => {
            return node[this.defaultProps.value] == item
          }, { children: this.defaultProps.children })
          if (find) {
            this.selectOptions.push(find)
          }
        })
      } else {
        const find = treeFind(this.options, node => {
          return node[this.defaultProps.value] == this.value
        }, { children: this.defaultProps.children })
        if (find) {
          this.selectOptions.push(find)
        }
      }
    },
    // 节点被点击时的回调
    handleNodeClick(data, node, el) {
      // 多选不做处理
      if (!this.multiple) {
        // 判断是否需要返回叶子节点
        if (this.isLeaf) {
          // 如果是叶子节点
          if (node.isLeaf && !node.disabled) {
            this.$refs.tree.setCheckedKeys([])
            this.$refs.tree.setChecked(data, true, false)
            this.$emit('change', node.key)
            this.$emit('input', node)
            this.$refs.select.blur()
          } else {
            // 不需要处理

          }
        } else {
          if (!node.disabled) {
            this.$refs.tree.setCheckedKeys([])
            this.$refs.tree.setChecked(data, true, false)
            this.$emit('change', node.key)
            this.$emit('input', node)
            this.$refs.select.blur()
          } else {
            // 不需要处理

          }
        }
      } else {
        // 多选不需要处理
      }
    },
    // 当复选框被点击的时候触发
    handleCheckChange(data, { checkedNodes, checkedKeys, halfCheckedNodes, halfCheckedKeys }) {
      if (this.isLeaf) {
        const nodes = this.$refs.tree.getCheckedNodes(true, false).filter(item => !item.disabled)
        this.$emit('change', nodes.map(item => item[this.defaultProps.value]))
        this.$emit('input', nodes)
      } else {
        const nodes = checkedNodes.filter(item => !item.disabled)
        this.$emit('change', nodes.map(item => item[this.defaultProps.value]))
        this.$emit('input', nodes)
      }
    },
    // 节点过滤
    filterNode(value, data) {
      if (!value) return true
      // 如果显示文本和tree不一致，使用显示文本搜索
      if (this.defaultProps.selectlabel) {
        return data[this.defaultProps.selectlabel].indexOf(value) !== -1
      } else {
        return data[this.defaultProps.label].indexOf(value) !== -1
      }
    }
  }

}
</script>

<style lang="scss">
.um-select-tree{
  display: inline-block;

}
</style>
